import React from 'react';

import RestClient from '../rest/RestClient';
import Entrance from './Entrance';
import MicroEvent  from '../other/microevent';
import Dropdown from 'react-dropdown';
import CommonHelper from '../helpers/CommonHelper';
import { confirmAlert } from 'react-confirm-alert';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Obtainer from '../helpers/Obtainer';

export default class UnlinkAccount extends React.Component {

  state = {
    redirectToReferrer: false,
    submitStarted:false,
    submitFailed: false,
    submitSucceeded: false,
  }

  constructor(props) {
    super(props);

    MicroEvent.mixin(UnlinkAccount);
    this.state = {
      showErrors:                         false,
      //validationErrors:                   { },
      restError:                          null,
      secondsLeftToNewAccountRedirection: 4,
      idx:null,
      options:[{value:-1,label:'Please wait...'} ],
      dropdownPlaceHolder:'Loading accounts ...',
      selectedAccountId:null,
    }

    this._onSelect = this._onSelect.bind(this)

    Obtainer.mixin(UnlinkAccount);

    this.bindObtain(
      this.OBTAINS().REMOVABLE_ACCOUNTS,
      null,
      (arrOfAccounts)=>{

        var acs = [];
        for (var i=0; i < arrOfAccounts.length; i++) {
            var newEl = {};
            newEl['value'] = arrOfAccounts[i].id;
            newEl['label'] = arrOfAccounts[i].login;
            acs.push(newEl);
        }

        this.setState({options: acs});
        var dropdownPlaceHolder = (arrOfAccounts.length > 0)?'Select an account to unlink':'No removable accounts';
        this.setState({dropdownPlaceHolder:dropdownPlaceHolder});
        this.selectOptionWithAccountId(Entrance.accountId());
      },
      null
    );
  }

  componentDidMount() {
    this.startObtain(this.OBTAINS().REMOVABLE_ACCOUNTS);
  }

  componentWillUnmount(){
    this.cancelObtain(this.OBTAINS().REMOVABLE_ACCOUNTS);
  }

  selectOptionWithAccountId(accountId) {
    var arrayLength = this.state.options.length;
    for (var i = 0; i < arrayLength; i++)
    {
      var option = this.state.options[i];
      if (option.value == accountId)
      {
        //console.log('equ');
        this.setState({idx: i});
        break;
      }
    }
  }

  _onSelect (option) {
    this.selectOptionWithAccountId(option.value);

    //this.setState({selectedAccountId:option.value});
    this.setState({selectedAccountId:option.value});
    //this.setState({idx:option.value});
  }


  submit = () => {
    confirmAlert({
     title: 'Account removal',                        // Title dialog
     message: 'Are you sure you want to unlink account?',               // Message dialog
     //childrenElement: () => <div>Custom UI</div>,       // Custom UI or Component
     confirmLabel: 'Yes, I\'m sure',                           // Text button confirm
     cancelLabel: '<<Back',                             // Text button cancel
     onConfirm: () => this.unlinkAccount(),    // Action after Confirm
     //onCancel: () => alert('Action after Cancel'),      // Action after Cancel
     onCancel: () => null,
   })
  }

  unlinkAccount = () => {
    this.setState({showErrors: true});

    this.setState({ submitStarted: true });
    this.setState({ submitFailed: false });
    this.setState({ submitSucceeded: false });


    RestClient.unlinkAccount(this.state.selectedAccountId, () => {
      this.setState({ submitSucceeded: true });
      this.setState({ submitStarted: false });
      this.setState({ submitFailed: false });

      this.trigger('reloadSwitchAccountCombo');

    },
    (error) => {
      //console.log('authentication error');
      this.setState({ restError: error});
      this.setState({ submitStarted: false });
      this.setState({ submitFailed: true });
    })
  }


  countdownOfRedirectionToNewAccount(){
    var secondsLeft = (this.state.secondsLeftToNewAccountRedirection - 1);
    console.log('countdownOfRedirectionToNewAccount:' + secondsLeft);
    this.setState({secondsLeftToNewAccountRedirection:secondsLeft});

    if (secondsLeft === 0) {
      clearInterval(this.state.refreshIntervalId);
    }
  }

  render() {
    if (this.state.submitSucceeded) { //it is flag of success indeed
      return (
        <div className="login-page">
          <Container align="center">
            <Row>
              <Col>
                 <h3>Unlink completed successfully!</h3>
              </Col>
            </Row>
          </Container>

        </div>
      )
    }

    var authMessage0 = (Entrance.accountsMissingAtLastLogin())?
    'You can now authorize your 1st SoundCloud (SC) account.'
    :
    'You can remove here any from your additional SC accounts, except currently selected.';

    var authMessage1 = (this.state.submitStarted)
        ? (<div className="waiting">Authenticating<br/></div>):'';

    var authMessage2 = (this.state.submitFailed)
        ? (<p className="text-red">Unlinking failed: <i>{this.state.restError.message}</i></p>):'';

    return  (
      <div className="login-page">
        <Container align="center">
          <Row>
            <Col>
            <p>{authMessage0}</p>
            {authMessage1}
            {authMessage2}
            </Col>
          </Row>
          <Row className='mb-5'>
            <Col>
              <Dropdown baseClassName="UnlinkAccountDropdown sc-dropdown"
                    options={this.state.options} 
                    onChange={this._onSelect} 
                    value={this.state.options[this.state.idx]} 
                    placeholder={this.state.dropdownPlaceHolder}
                />
            </Col>
          </Row>
          <Row>
            <Col>
              <button disabled={CommonHelper.isNull(this.state.selectedAccountId)} 
                      type='submit' 
                      id="red" 
                      className="sc-btn sc-btn-red sc-btn-big" 
                      onClick={this.submit}>Remove
                </button>
            </Col>
          </Row>
        </Container>

      </div>
     );
   }
 }
